import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";

const GROUP_ORDER = ["Hard Costs", "Soft Costs"];

// Grouped category picker. `categories` = [{id,name,group,description}]. Stores the category name string.
export function CategorySelect({ categories = [], value, onChange, placeholder = "Select category", testId, className }) {
  const groups = {};
  for (const c of categories) {
    const g = c.group || "Other";
    (groups[g] = groups[g] || []).push(c);
  }
  const orderedGroups = [
    ...GROUP_ORDER.filter((g) => groups[g]),
    ...Object.keys(groups).filter((g) => !GROUP_ORDER.includes(g)).sort(),
  ];
  const known = categories.some((c) => c.name === value);

  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger className={className || "mt-2 rounded-none"} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-[300px]">
        {value && !known && <SelectItem value={value}>{value}</SelectItem>}
        {orderedGroups.map((g) => (
          <SelectGroup key={g}>
            <SelectLabel className="label-caps text-xs">{g}</SelectLabel>
            {groups[g].map((c) => (
              <SelectItem key={c.id} value={c.name} title={c.description || ""}>
                <span className="flex items-center gap-2">
                  <span>{c.name}</span>
                  {c.budget_pct && <span className="text-[10px] text-muted-foreground font-mono-fig">{c.budget_pct}</span>}
                </span>
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
